import { authActions } from '@shared/redux/ducks/auth';
import {
  generatedApi,
  type OrganizationInfo,
  type ShortOrganizationForUser,
} from '@shared/api/generated-api';
import type { RootState } from '@shared/redux/root-state';

export const authEndpoints = {
  getMeUserMeGet: {
    async onQueryStarted(_, { dispatch, queryFulfilled }) {
      const { data } = await queryFulfilled;
      dispatch(authActions.setUserInfo(data));
    },
  },

  getOrganizationListOrganizationListGet: {
    providesTags: ['organization'] as const,
  },

  createOrganizationOrganizationCreatePost: {
    invalidatesTags: [],
    async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
      const { data }: { data: OrganizationInfo } = await queryFulfilled;

      const shortOrganizationInfo: ShortOrganizationForUser = {
        id: data.id,
        title: data.title,
        permission: 'OWNER',
        credit_balance: data.credit_balance,
      };

      dispatch(authActions.addUserOrganization(shortOrganizationInfo));
      dispatch(authActions.setCurrentOrganizationInfo(shortOrganizationInfo));
      dispatch(authActions.setCurrentOrganizationName(data.title));

      const cachedOrganizationListArgs = generatedApi.util.selectCachedArgsForQuery(
        getState(),
        'getOrganizationListOrganizationListGet',
      );

      const cachedGetMeArgs = generatedApi.util.selectCachedArgsForQuery(
        getState(),
        'getMeUserMeGet',
      );

      for (const args of cachedOrganizationListArgs) {
        dispatch(
          generatedApi.util.updateQueryData(
            'getOrganizationListOrganizationListGet',
            args,
            (draft) => {
              draft.unshift(data);
            },
          ),
        );
      }

      for (const args of cachedGetMeArgs) {
        dispatch(
          generatedApi.util.updateQueryData('getMeUserMeGet', args, (draft) => {
            draft.organizations = [
              ...(draft.organizations || []),
              {
                id: data.id,
                title: data.title,
                permission: 'OWNER',
                credit_balance: data.credit_balance,
              },
            ];
          }),
        );
      }
    },
  },

  changeNameOrganizationOrganizationChangeNamePost: {
    async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
      const { data }: { data: OrganizationInfo } = await queryFulfilled;
      const state = getState() as RootState;
      const storedOrganization = state.auth.userInfo?.organizations?.find(
        (organization) => organization.id === data.id,
      );

      if (storedOrganization) {
        const updatedOrganization: ShortOrganizationForUser = {
          ...storedOrganization,
          title: data.title,
          credit_balance: data.credit_balance,
        };

        dispatch(authActions.updateUserOrganization(updatedOrganization));

        if (state.auth.currentOrganizationInfo.id === data.id) {
          dispatch(authActions.setCurrentOrganizationInfo(updatedOrganization));
        }
      }

      const cachedGetMeArgs = generatedApi.util.selectCachedArgsForQuery(
        getState(),
        'getMeUserMeGet',
      );

      for (const args of cachedGetMeArgs) {
        dispatch(
          generatedApi.util.updateQueryData('getMeUserMeGet', args, (draft) => {
            const organization = draft.organizations?.find((item) => item.id === data.id);

            if (organization) {
              organization.title = data.title;
              organization.credit_balance = data.credit_balance;
            }
          }),
        );
      }
    },
  },
} satisfies Parameters<typeof generatedApi.enhanceEndpoints>[0]['endpoints'];
